import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
import { motion } from 'framer-motion';
import { DownloadIcon } from 'lucide-react';
export function HeroSection() {
  const scrollToCTA = () => {
    const ctaSection = document.getElementById('final-cta');
    if (ctaSection) {
      ctaSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="bg-brand-bg py-10 sm:py-16 px-4" data-id="element-160">
      <div className="max-w-content mx-auto text-center" data-id="element-161">
        <FadeIn data-id="element-162">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-serif font-bold text-brand-text leading-tight mb-6" data-id="element-163">
            Cómo Verte Más Delgada y Estilizada Sin Bajar de Peso Ni Comprar
            Ropa Nueva
          </h1>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-164">
          <p className="text-base sm:text-lg font-medium text-brand-text/80 mb-8 max-w-xl mx-auto" data-id="element-165">
            La fórmula visual que cambia cómo se ve tu cuerpo en minutos usando
            prendas que ya tienes en tu closet
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-166">
          <div className="relative w-full max-w-md mx-auto mb-6 aspect-[3/4] sm:aspect-square" data-id="element-167">
            <img src="https://cdn.magicpatterns.com/uploads/f7LEfb6CDQ2FyjEpK2R533/portada.png" alt="Closet Flaco Express eBook Mockup" className="w-full h-full object-contain drop-shadow-2xl" data-id="element-168" />
          </div>

          <motion.button onClick={scrollToCTA} className="relative inline-flex items-center gap-3 text-[#1A1A1A] font-bold py-5 px-10 rounded-full shadow-xl text-xl sm:text-2xl cursor-pointer overflow-hidden mb-6 tracking-wide" style={{
          backgroundColor: '#FFD600'
        }} whileHover={{
          scale: 1.07
        }} whileTap={{
          scale: 0.95
        }} animate={{
          boxShadow: ['0 0 0 0 rgba(255, 214, 0, 0.5)', '0 0 0 16px rgba(255, 214, 0, 0)', '0 0 0 0 rgba(255, 214, 0, 0)'],
          y: [0, -4, 0],
          scale: [1, 1.03, 1]
        }} transition={{
          boxShadow: {
            duration: 1.8,
            repeat: Infinity,
            ease: 'easeInOut'
          },
          y: {
            duration: 1.8,
            repeat: Infinity,
            ease: 'easeInOut'
          },
          scale: {
            duration: 1.8,
            repeat: Infinity,
            ease: 'easeInOut'
          }
        }} data-id="element-169">
            <DownloadIcon className="w-7 h-7" strokeWidth={2.5} data-id="element-170" />
            <span data-id="element-171">¡DESCARGA YA!</span>
            <span className="bg-[#1A1A1A] text-[#FFD600] rounded-full py-1 px-4 text-lg font-extrabold shadow-inner" data-id="element-172">
              $8,99
            </span>
          </motion.button>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-173">
          <Button onClick={scrollToCTA} fullWidth className="mb-4" data-id="element-174">
            🚀 ¡QUIERO VERME ESTILIZADA AHORA!
          </Button>

          <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-2 text-sm text-brand-text/70 font-medium" data-id="element-175">
            <span className="flex items-center gap-1" data-id="element-176">
              ✓ Descarga instantánea
            </span>
            <span className="flex items-center gap-1" data-id="element-177">✓ Formato PDF</span>
            <span className="flex items-center gap-1" data-id="element-178">
              ✓ Garantía de 7 días
            </span>
          </div>
        </FadeIn>
      </div>
    </section>;
}